import React from 'react';
import { Route } from 'react-router-dom';
import Layout from '../../../Layout/index';
import Forms from './Forms';
import Account from './Account';

export default () => (
  <div>
    <Layout />
    <div className="container__wrap">
      {/* <Route path="/home" component={HomeDashboard} /> */}

      <Route path="/forms" component={Forms} />
      <Route path="/account" component={Account} />

    </div>
  </div>
);
